import { attachAuthInterceptors } from '@repo/auth/axios';
import axios from 'axios';

import { authClient } from 'src/app/auth/auth-client';
import { getLocale } from 'src/packages/language/utils';

import { WELL_DIRECTORY_SERVICE_API_URL } from './consts';

const agent = axios.create({
  baseURL: WELL_DIRECTORY_SERVICE_API_URL,
  headers: {
    'content-type': 'application/json',
  },
});

attachAuthInterceptors(agent, authClient);

agent.interceptors.request.use((config) => {
  config.headers['accept-language'] ??= getLocale();
  return config;
});

export { agent as wellDirectoryServiceAgent };
